/*
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */

import { GuestUIFrame } from '@adobe/uix-host-react'
import { useContext } from 'react'
import { UixContext } from './UixContainer'

export const updatePageTitle = (pageTitle: string) => {
  document.title = pageTitle + ' / Adobe Commerce Admin'
  const querySelector = document.querySelector('.page-title')
  if (querySelector) {
    querySelector.textContent = pageTitle
  }
}

interface UixFrameProps {
  url: string
  extensionId: string
  redirectUrl: string
}

export function UixFrame({ url, extensionId, redirectUrl }: UixFrameProps) {
  const uixContext = useContext(UixContext)

  return (
    <>
      <GuestUIFrame
        src={url}
        guestId={extensionId}
        onConnect={() => {
          if (uixContext.setConnected) {
            uixContext.setConnected(true)
          }
        }}
        onDisconnect={console.log}
        privateMethods={{
          field: {
            close: () => {
              window.location.href = redirectUrl
            },
            onError: () => {
              window.location.href = redirectUrl + '?error=true'
            }
          }
        }}
        width={'100%'}
        style={{
          border: 'none',
          height: '100vh'
        }}
      />
    </>
  )
}
